import * as React from "react";
import { useMemo } from "react";
import { AdditionalContext } from "views/logic/ActionContext";
import WidgetContext from "views/components/contexts/WidgetContext";
import ExportSettingsContextProvider from "views/components/ExportSettingsContextProvider";
import View from "views/logic/views/View";
import defaultTitle from "views/components/defaultTitle";
import TitleTypes from "views/stores/TitleTypes";
import useViewType from "views/hooks/useViewType";
import useWidget from "views/hooks/useWidget";
import useActiveViewState from "views/hooks/useActiveViewState";
import Widget from "./widgets/Widget";
import DrilldownContextProvider from "./contexts/DrilldownContextProvider";
import WidgetFieldTypesContextProvider from "./contexts/WidgetFieldTypesContextProvider";
const useTitle = (widget) => {
  var _a;
  const activeViewState = useActiveViewState();
  return (_a = activeViewState == null ? void 0 : activeViewState.titles) == null ? void 0 : _a.getIn([TitleTypes.Widget, widget.id], defaultTitle(widget));
};
const WidgetComponent = ({ editing, onPositionsChange = () => void 0, position, widgetId }) => {
  const widget = useWidget(widgetId);
  const viewType = useViewType();
  const title = useTitle(widget);
  const additionalContext = useMemo(() => ({ widget }), [widget]);
  const WidgetFieldTypesIfDashboard = viewType === View.Type.Dashboard ? WidgetFieldTypesContextProvider : React.Fragment;
  return /* @__PURE__ */ React.createElement(DrilldownContextProvider, { widget }, /* @__PURE__ */ React.createElement(WidgetContext.Provider, { value: widget }, /* @__PURE__ */ React.createElement(AdditionalContext.Provider, { value: additionalContext }, /* @__PURE__ */ React.createElement(ExportSettingsContextProvider, null, /* @__PURE__ */ React.createElement(WidgetFieldTypesIfDashboard, null, /* @__PURE__ */ React.createElement(
    Widget,
    {
      editing,
      id: widget.id,
      onPositionsChange,
      position,
      title,
      widget
    }
  ))))));
};
export default WidgetComponent;
